var map = {
	"./avatar-organizacao/leao.svg": "f31a",
	"./avatar-organizacao/leo.svg": "1df3",
	"./avatar-organizacao/robo.svg": "05dc",
	"./cluster-logo/horizontal_logo.svg": "f037",
	"./cluster-logo/horizontal_menu_logo.png": "3166",
	"./cluster-logo/horizontal_menu_logo.svg": "ec81",
	"./cluster-logo/horizontal_menu_logo_dark.svg": "357f",
	"./cluster-logo/vertical_logo.svg": "353d",
	"./cluster-logo/vertical_logo_dark.svg": "cfdc",
	"./clustervet_icon.png": "1999",
	"./clustervet_logo_hex.png": "17af",
	"./hubvet_icon.svg": "44d83",
	"./hubvet_logo.svg": "c1a3",
	"./hubvet_logo_hex.svg": "4b76",
	"./icons/mdiBookSearchOutline.svg": "93fe",
	"./illustrations/HandShake.svg": "d313",
	"./illustrations/Padlock.svg": "11cd",
	"./import-photos/avatarOrg.png": "cd04",
	"./import-photos/avatarUser.png": "ec6d",
	"./import-photos/cliente-photo.svg": "10bf",
	"./import-photos/photoImport1.svg": "ad14",
	"./import-photos/photoImport2.svg": "ff3e",
	"./langs/en_us.png": "7e0a",
	"./langs/es.png": "2583",
	"./langs/pt_br.png": "1a5b",
	"./logo-horizontal-dark.svg": "cb6f",
	"./logo-horizontal.png": "85eb",
	"./logo-horizontal.svg": "5e52",
	"./logo-vertical-dark.svg": "dd0f",
	"./logo-vertical.svg": "ff18",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./logo_horizontal_clustervet.svg": "5dd7",
	"./logo_vertical_clustervet.svg": "0a97",
	"./not-found.svg": "16d4",
	"./pet_default.svg": "38dd",
	"./preview-exam.png": "be3b",
	"./user_blank.gif": "9c93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";